import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addLead,
  getLeads,
  getLead,
  editLead,
  deleteLead,
  getAllLeads,
} from "../../store/actions/lead_action";
import _debounce from "lodash/debounce";
import { useSelectAllGroup } from "../hooks/UseGroup"
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllLeads = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.lead);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);



  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteLead(deleteEntry));
    }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {

      dispatch(
        getLeads({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data, setPageNumber, deleteBtnClicked
  ];
};

// Get Single Data
export const useSingleLead = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.lead);
  useEffect(() => {
    dispatch(getLead(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateLead = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.lead);
  const addData = async (data) => {
    await dispatch(addLead(data));
  };
  return [data, addData];
};
export const useUpdateLead = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.lead);
  const updateData = async (id, data) => {
    await dispatch(editLead(id, data));
  };
  return [updateData];
};

export const useSelectAllLead = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.lead);
  useEffect(() => {
    dispatch(getAllLeads({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};


export const useGetDropdownOptions = () => {


  const [group] = useSelectAllGroup();

  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

  useEffect(() => {
    if (group && group.all_groups) {
      const newData = group.all_groups.map((item) => {
        return { label: item.name, value: item.name };
      });
      setDropdownOptions({ ...dropdownOptions, group: newData });
    }
  }, [group]);


  return [dropdownOptions
    // setClientSearchField, setClientSearchValue
  ];
};